import { Component, OnInit } from '@angular/core';


declare const jQuery: any;


@Component({
  selector: 'app-miinteressa',
  templateUrl: './miinteressa.component.html',
  styleUrls: ['./miinteressa.component.css', '../../styles/main2.css', '../../styles/bff36bfa-92c9-4b5f-9ec6-a50300d6c6b3.css']
})
export class MiinteressaComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
      this.doAnimation();
  }

  doAnimation() {
        (function(a, b) {
            a("#sira").liteAccordion({
                onTriggerSlide: function() {
                    this.find("figcaption").fadeOut()
                },
                onSlideAnimComplete: function() {
                    this.find("figcaption").fadeIn()
                },
                autoPlay: true,
                pauseOnHover: true,
                theme: "stitch",
                rounded: true,
                enumerateSlides: true
            }).find("figcaption:first").show()
        })(jQuery, document);
  }

}
